export default __webpack_public_path__ + "static/media/jad.png.webp";